import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Switch from 'material-ui/Switch';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import ContainerHeader from '../../../components/ContainerHeader/index';
import CardBox from '../../../components/CardBox/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as addUserDetails from '../../../actions/userdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as lookup from '../../../actions/lookup';
import * as toaster from '../../../actions/toaster';

import UserRequest from '../../../api/requests/UserRequest'

import { filter, find, includes, map, some } from 'lodash'
import * as regData from '../../../../appConstants'


class Approve extends Component {

    constructor(props) {
        super(props)
        this.state = {
            id: this.props.params.id,
            user: {
                id: '',
                user_id: '',
                user_name: '',
                email_id: '',
                isBadmin: false,
                isChecker: false,
                operation: '',
                userRoleCommittee: [],
                pendingRoleCommittee: []
            }
        }
    }

    handleChange(field, e) {
        // this.setState({ [name]: event.target.value });
        // console.log('e.target.value', e.target.checked);
        // console.log('field', field);
        if (field == 'isBadmin' || field == 'isChecker') {
            const user = Object.assign({}, this.state.user, { [field]: e.target.checked });
            this.setState(Object.assign({}, this.state, { user }));
            // console.log('this.state', this.state);
        }
        else {
            const user = Object.assign({}, this.state.user, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { user }));
        }
        // console.log(this.state)
    };

    handleSubmit(e) {
        e.preventDefault();
    };

    getAddRoleData = (data) => {
        // console.log("getAddRoleData", data);
        let _rolefound = false;
        let _committeefound = find(this.state.user.userRoleCommittee, { "committee_id": data.committee_id });
        if (_committeefound) {
            // console.log('data.role', data.role)
            // console.log("_committeefound", _committeefound);
            _rolefound = some(_committeefound.roles, (v) => includes(data.role, v));
            // console.log('_rolefound', _rolefound)
        }
        if (!_rolefound) {
            this.state.user.userRoleCommittee.push({ committee_id: data.committee_id, roles: data.role });
            const user = Object.assign({}, this.state.user, { ['userRoleCommittee']: this.state.user.userRoleCommittee });

            this.setState(Object.assign({}, this.state, { user }));
            // console.log("this.state.userRole", this.state.userRole);
        }
        else
            this.props.actions.warningToasters('User Role is already assigned');
        data = null;
    }

    getRolesList(_array, _RoleList) {
        let res = filter(_RoleList, (v) => find(_array, { 'role_id': v.id }));
        // console.log('_array', _array)
        // console.log('res', res)
        return map(res, 'name').join(",");
    }

    onApproveUserRole = (e) => {
        e.preventDefault()
        if (this.state.user.id)
            this.props.actions.approveUser(this.state.user.id);
    };

    onRejectUserRole = (e) => {
        e.preventDefault()
        if (this.state.user.id)
            this.props.actions.rejectUser(this.state.user.id);
    };

    componentDidMount() {
        // console.log('props', this.props)
        if (this.state.id)
            this.props.actions.getPendingUserDetails(this.state.id);
        this.props.actions.getAddUserRoleLookup();
        this.props.actions.loadswitchercommittees();
    }
    render() {
        const { loginUser, getAddUserRoleLookup, teamDetails, userDetails, match } = this.props;
        const RoleList = getAddUserRoleLookup.lookupList;
        const CommitteeList = teamDetails.switchteamdetailsList;
        let dataList = <tr><td></td></tr>;
        let result = null;
        // console.log('props', this.props)
        if ((getAddUserRoleLookup && getAddUserRoleLookup.Status) || (teamDetails && teamDetails.Status)
            || (userDetails && userDetails.Status) || (userDetails && userDetails.actionStatus)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        // console.log('userDetails.Userdetails', userDetails.Userdetails);
        if (userDetails.Userdetails && userDetails.Userdetails.id && !this.state.user.id) {
            // console.log('userDetails.Userdetails', userDetails.Userdetails);
            this.state.user = userDetails.Userdetails;
            // console.log('this.state.user = ', this.state.user)
        }
        if (this.state.user.pendingRoleCommittee) {
            dataList = this.state.user.pendingRoleCommittee.map((_data, index) => {
                let committeeItem = find(CommitteeList, { "id": _data.committee_id });
                // console.log(committeeItem)
                if (committeeItem)
                    return (<tr key={index}>
                        <td>{index + 1}</td>
                        <td>{committeeItem.name}</td>
                        <td>{this.getRolesList(_data.roles, RoleList)}</td>
                        {/* <td></td> */}
                    </tr>);
            });
        }
        // if (userDetails && userDetails.actionResult)
        //     this.props.history.push('/user/pending-approval');
        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Approve User" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">User Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="userName" label="User Name" disabled
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                                value={this.state.user.user_name} onChange={this.handleChange.bind(this, 'user_name')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="userId" label="User Id" disabled
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                                value={this.state.user.user_id} onChange={this.handleChange.bind(this, 'user_id')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="email" label="Email Address" disabled
                                                validators={['required', 'isEmail']}
                                                errorMessages={['This field is required', 'email is not valid']}
                                                value={this.state.user.email_id} onChange={this.handleChange.bind(this, 'email_id')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            {/* <input type="file" id="fileupload" className="mt-0 mb-4 col-md-6" /> */}

                                            <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }} disabled
                                                checked={this.state.user.isBadmin} onChange={this.handleChange.bind(this, 'isBadmin')} />
                                            } label="IT Admin" />
                                            <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }} disabled
                                                checked={this.state.user.isChecker} onChange={this.handleChange.bind(this, 'isChecker')} />
                                            } label="Checker" />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="operation" label="Add/Update/Delete" disabled
                                                errorMessages={['This field is required']}
                                                value={this.state.user.operation ? ' ' + this.state.user.operation : ''} onChange={this.handleChange.bind(this, 'operation')} />
                                        </div>

                                    </div>
                                </CardBody>
                            </Card>
                            <Card className="shadow border-2">
                                <CardBody>
                                    <h3 className="card-title">Approval Pending Roles</h3>
                                    <div className="col-md-12">
                                        <div className="table-responsive-material">
                                            <table className="default-table table-unbordered table table-lg table-hover">
                                                <thead className="th-border-b">
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>Team Name</th>
                                                        <th>User Roles</th>
                                                        {/* <th className="status-cell text-right">Actions</th> */}
                                                        {/* <th /> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataList}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <div>
                                {(loginUser && loginUser.data && loginUser.data.role_id == "5") ? <Button variant="raised" className="jr-btn bg-primary text-white"
                                    onClick={this.onApproveUserRole.bind(this)}>Approve</Button> : null}
                                {(loginUser && loginUser.data && loginUser.data.role_id == "5") ? <Button variant="raised" className="jr-btn bg-danger text-white"
                                    onClick={this.onRejectUserRole.bind(this)}>Reject</Button> : null}
                                    {(loginUser && loginUser.data && loginUser.data.role_id == "5") ? <Button variant="raised" className="jr-btn bg-grey text-white" 
                                    onClick={()=>{this.props.history.push('/user/checker-pending-approval')}}>Cancel</Button>
                                    :
                                    <Button variant="raised" className="jr-btn bg-grey text-white" 
                                    onClick={()=>{this.props.history.push('/user/pending-approval')}}>Cancel</Button>}
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(state)
    const { loginUser, userDetails, getAddUserRoleLookup, teamDetails } = state
    const { match } = ownProps
    // console.log('ownProps.match.params', ownProps)
    return { loginUser, userDetails, getAddUserRoleLookup, teamDetails, match, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, addUserDetails, loadswitchercommittees, lookup, toaster), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Approve));



// WEBPACK FOOTER //
// ./app/userdetails/approve/index.js